import React from 'react';
import styles from './ContinueSessionModal.module.scss';

const ContinueSessionModal = ({
    isVisible,
    selectedSection,
    onContinue,
    onStartFresh
}) => {
    if (!isVisible) return null;

    return (
        <div className={styles.modalOverlay}>
            <div className={styles.modal}>
                <h2>Continue Previous Session?</h2>
                <p>You have an ongoing {selectedSection} practice session. Would you like to continue from where you left off?</p>
                <div className={styles.modalButtons}>
                    <button
                        className={styles.primaryButton}
                        onClick={onContinue}
                    >
                        Continue Session
                    </button>
                    <button
                        className={styles.secondaryButton}
                        onClick={onStartFresh}
                    >
                        Start Fresh
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ContinueSessionModal;